import { render, staticRenderFns } from "./hot_spo_new.vue?vue&type=template&id=1fedaf6c&scoped=true"
import script from "./hot_spo_new.vue?vue&type=script&lang=js"
export * from "./hot_spo_new.vue?vue&type=script&lang=js"
import style0 from "./hot_spo_new.vue?vue&type=style&index=0&id=1fedaf6c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fedaf6c",
  null
  
)

export default component.exports